<script lang="ts">
  import type {
    ScreenBadge,
    ScreenHint,
    SpawnTelegraph,
    TrafficBadge,
  } from "../overlays";
  import type { ScorePopup } from "../popups";
  import Icon from "./Icon.svelte";

  const {
    badges = [],
    traffic = null,
    hint = null,
    popups = [],
    popupLifeMs = 1100,
    telegraphs = [],
  }: {
    badges?: readonly ScreenBadge[];
    traffic?: TrafficBadge | null;
    hint?: ScreenHint | null;
    popups?: readonly ScorePopup[];
    /** Drives the CSS animation, so one number governs both halves. */
    popupLifeMs?: number;
    telegraphs?: readonly SpawnTelegraph[];
  } = $props();
</script>

<div class="world-layer" aria-hidden="true">
  {#each badges as badge (badge.key)}
    <span class="badge" style="left: {badge.x}px; top: {badge.y}px">
      {#if badge.symbol}
        <span class="badge__symbol" style="color: {badge.color}"
          >{badge.symbol}</span
        >
      {:else}
        <span class="badge__dot" style="background: {badge.color}"></span>
      {/if}
      {badge.label}
    </span>
  {/each}

  {#if traffic}
    <span class="badge" style="left: {traffic.x}px; top: {traffic.y}px">
      <Icon name="plane" size={12} />
      {traffic.count}
    </span>
  {/if}

  {#each telegraphs as telegraph (telegraph.key)}
    <span
      class="telegraph"
      style="left: {telegraph.x}px; top: {telegraph.y}px; color: {telegraph.color}; --telegraph-urgency: {telegraph.progress}"
    >
      <span
        class="telegraph__arrow"
        style="transform: rotate({telegraph.angle}deg)">➤</span
      >
      {#if telegraph.symbol}
        <span class="telegraph__symbol">{telegraph.symbol}</span>
      {/if}
      <span class="telegraph__count">{telegraph.seconds}s</span>
    </span>
  {/each}

  {#each popups as popup (popup.key)}
    <span
      class="popup"
      style="left: {popup.x}px; top: {popup.y}px; color: {popup.color}; animation-duration: {popupLifeMs}ms"
    >
      {popup.text}
    </span>
  {/each}

  {#if hint}
    <span
      class="tooltip"
      style="left: {hint.x}px; top: {hint.y}px"
      data-anchor-x={hint.anchorX}
      data-anchor-y={hint.anchorY}
    >
      {hint.text}
    </span>
  {/if}
</div>
